import SEOHead from '@/components/feature/SEOHead';
import Layout from '@/components/feature/Layout';

const aboutSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于日韩在线 - 日韩国产在线与日韩激情在线品牌介绍',
    description: '日韩在线是专业的日韩视频内容平台，汇聚日韩国产在线、日韩激情在线、日韩精品在线、日韩久久在线等全部分区，提供日韩剧、综艺、动漫等最新高清视频。',
    url: 'https://rihanzaixian.com/about',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://rihanzaixian.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://rihanzaixian.com/about',
      },
    ],
  },
];

const reviews = [
  { name: '张**', rating: 5, content: '资源真的超全！日韩国产在线和日韩激情在线的内容更新很快，画质也很清晰，是我每天必看的网站。', date: '2025-07-28' },
  { name: '李**', rating: 5, content: '日韩精品在线专区的影片质量特别高，每一部都是精心挑选的好片。日韩久久在线也有很多经典老剧可以回味。', date: '2025-07-25' },
  { name: '王**', rating: 5, content: '自从发现了日韩在线，追日剧韩剧就再也不用到处找资源了。日韩高清在线一区的画质真的绝了！', date: '2025-07-22' },
  { name: '陈**', rating: 5, content: '综艺更新速度很及时，日韩综艺在线的内容和韩国播出的基本同步。推荐给了很多朋友，都说好用。', date: '2025-07-20' },
  { name: '刘**', rating: 4, content: '作为日漫粉，日韩动漫在线的番剧库太强大了。新番老番都有，而且中文字幕质量很高，体验非常好。', date: '2025-07-18' },
  { name: '赵**', rating: 5, content: '不缓冲的观看体验真的棒！日韩高清在线一区二区的视频加载速度很快，即使在手机上看也完全不卡。', date: '2025-07-15' },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 日韩在线 | 日韩国产在线与日韩激情在线品牌介绍"
        description="日韩在线品牌介绍——汇聚日韩国产在线、日韩激情在线、日韩精品在线及日韩久久在线等全部分区，提供日韩剧、综艺、动漫等最新高清视频免费在线观看的平台。了解我们的品牌故事与联系方式。"
        keywords="日韩在线,关于日韩在线,日韩国产在线品牌,日韩激情在线平台,日韩精品在线介绍,日韩久久在线,日韩高清在线"
        canonicalUrl="https://rihanzaixian.com/about"
        schemaData={aboutSchema}
      />

      <Layout>
        <div className="pt-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <a href="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <section id="intro" className="mb-16">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-8">
                关于日韩在线
              </h1>

              <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
                <div className="lg:w-3/5">
                  <h2 className="text-lg font-heading font-bold text-foreground-900 mb-4">品牌介绍</h2>
                  <div className="text-sm text-foreground-700 leading-relaxed space-y-4">
                    <p>
                      <strong>日韩在线</strong>是专业的日韩视频内容聚合平台，致力于为全球华人观众提供最全面、最高清的日韩影视内容。平台汇聚<strong>日韩国产在线</strong>、<strong>日韩激情在线</strong>、<strong>日韩精品在线</strong>、<strong>日韩久久在线</strong>以及<strong>日韩高清在线</strong>等五大分区，涵盖日剧、韩剧、日本动漫、韩国综艺、日本综艺、日韩电影等全品类内容。
                    </p>
                    <p>
                      自平台上线以来，日韩在线始终坚持「高清、快速、免费」的核心理念，采用先进的视频编码技术和全球CDN加速网络，确保用户无论是在PC端还是移动端，都能享受流畅不缓冲的极致观影体验。
                    </p>
                    <p>
                      我们的内容团队每日追踪日本和韩国的最新影视动态，确保热门剧集和综艺节目在播出后第一时间上线中文字幕版本。日韩在线不仅是一个视频观看平台，更是连接中日韩文化交流的桥梁。
                    </p>
                    <h2 className="text-lg font-heading font-bold text-foreground-900 pt-4">核心优势</h2>
                    <ul className="list-disc pl-5 space-y-2">
                      <li><strong>资源全面：</strong>日韩国产在线、日韩激情在线、日韩精品在线、日韩久久在线、日韩高清在线五大分区全覆盖</li>
                      <li><strong>高清画质：</strong>日韩高清在线一区二区提供1080P至4K超高清画质</li>
                      <li><strong>更新及时：</strong>日韩最新在线视频同步更新，播出后24小时内上线</li>
                      <li><strong>完全免费：</strong>日韩在线所有内容免费观看，无需付费会员</li>
                      <li><strong>多端适配：</strong>日韩剧在线观看支持PC、平板、手机无缝切换</li>
                    </ul>
                  </div>
                </div>

                <div className="lg:w-2/5">
                  <div className="bg-background-100 rounded-xl p-6 md:p-8">
                    <h2 className="text-lg font-heading font-bold text-foreground-900 mb-4">平台数据</h2>
                    <div className="grid grid-cols-2 gap-4">
                      {[
                        { label: '视频总量', value: '10,000+' },
                        { label: '日活用户', value: '50万+' },
                        { label: '内容分类', value: '5大分区' },
                        { label: '月更新量', value: '500+' },
                      ].map((stat) => (
                        <div key={stat.label} className="text-center p-4 bg-background-50 rounded-lg">
                          <div className="text-xl md:text-2xl font-heading font-bold text-accent-500 mb-1">
                            {stat.value}
                          </div>
                          <div className="text-xs text-foreground-600">{stat.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section id="reviews" className="mb-16">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-sm text-foreground-600 mb-8">
                来自日韩在线用户的真实评价，日韩国产在线与日韩激情在线深受用户喜爱
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reviews.map((review, index) => (
                  <div key={index} className="bg-background-100 rounded-xl p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`ri-star-fill text-sm ${i < review.rating ? 'text-accent-500' : 'text-background-300'}`}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      {review.content}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span className="font-medium">{review.name}</span>
                      <span>{review.date}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section id="contact" className="mb-8">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 mb-8">
                如有任何问题或合作意向，欢迎通过以下方式联系我们
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  {
                    icon: 'ri-mail-line',
                    title: '电子邮箱',
                    content: 'contact@rihanzaixian.com',
                    action: '发送邮件',
                  },
                  {
                    icon: 'ri-wechat-line',
                    title: '微信公众号',
                    content: '日韩在线官方',
                    action: '扫码关注',
                  },
                  {
                    icon: 'ri-service-line',
                    title: '客服热线',
                    content: '400-888-8888',
                    action: '拨打电话',
                  },
                ].map((item) => (
                  <div key={item.title} className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                      <i className={`${item.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-700 mb-3">{item.content}</p>
                    <span className="inline-block text-xs text-primary-600 font-medium cursor-pointer hover:text-primary-700 transition-colors">
                      {item.action}
                    </span>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </Layout>
    </>
  );
}